import { trustBadges } from '../../../mocks/sharedData';

export default function TrustBar() {
  const doubled = [...trustBadges, ...trustBadges];

  return (
    <section className="bg-white border-y border-slate-200 py-5 overflow-hidden">
      <div className="text-center mb-3">
        <span className="text-slate-400 text-xs font-semibold uppercase tracking-[0.2em]">
          Trusted by 500+ Homes &amp; Businesses · Certified Installers
        </span>
      </div>
      <div className="flex overflow-hidden">
        <div className="flex gap-4 animate-marquee whitespace-nowrap">
          {doubled.map((badge, index) => (
            <div
              key={`${badge.id}-${index}`}
              className="flex items-center gap-2.5 px-5 py-2.5 rounded-xl border border-slate-200 bg-slate-50 flex-shrink-0"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${badge.icon} text-orange-500 text-sm`} />
              </div>
              <span className="text-slate-700 text-sm font-semibold">{badge.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
